import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Inject, ɵɵdefineNgModule, ɵɵdefineInjector, NgModule, ɵɵsetNgModuleScope } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { AUTH_SERVICE_PROVIDER_TOKEN, AuthenticationServiceAbs } from 'baseauth';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';

class JwtInterceptor {
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    intercept(request, next) {
        if (request.headers.get('No-Auth') == "True") {
            return next.handle(request.clone());
        }
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.token) {
            //check if token is expired
            const clonedreq = request.clone({
                headers: request.headers.set("Authorization", "JWT " + currentUser.token)
            });
            return next.handle(clonedreq).pipe(tap(succ => { }, err => {
                if (err.status === 401) {
                    console.log("intercept 401  redirecting to login");
                    this.authenticationService.logout();
                    this.router.navigateByUrl('/login');
                }
            }));
        }
        else {
            console.log("intercept userToken is null redirecting to login");
            this.router.navigateByUrl('/login');
        }
        return next.handle(request);
    }
}
JwtInterceptor.ɵfac = function JwtInterceptor_Factory(t) { return new (t || JwtInterceptor)(ɵɵinject(Router), ɵɵinject(AUTH_SERVICE_PROVIDER_TOKEN)); };
JwtInterceptor.ɵprov = ɵɵdefineInjectable({ token: JwtInterceptor, factory: JwtInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(JwtInterceptor, [{
        type: Injectable
    }], function () { return [{ type: Router }, { type: AuthenticationServiceAbs, decorators: [{
                type: Inject,
                args: [AUTH_SERVICE_PROVIDER_TOKEN]
            }] }]; }, null); })();

class InterceptorsModule {
}
InterceptorsModule.ɵmod = ɵɵdefineNgModule({ type: InterceptorsModule });
InterceptorsModule.ɵinj = ɵɵdefineInjector({ factory: function InterceptorsModule_Factory(t) { return new (t || InterceptorsModule)(); }, providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
    ], imports: [[]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(InterceptorsModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                exports: [],
                providers: [
                    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
                ]
            }]
    }], null, null); })();

class FrBaseServicesModule {
}
FrBaseServicesModule.ɵmod = ɵɵdefineNgModule({ type: FrBaseServicesModule });
FrBaseServicesModule.ɵinj = ɵɵdefineInjector({ factory: function FrBaseServicesModule_Factory(t) { return new (t || FrBaseServicesModule)(); }, providers: [], imports: [[
            InterceptorsModule
        ], InterceptorsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FrBaseServicesModule, { imports: [InterceptorsModule], exports: [InterceptorsModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(FrBaseServicesModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    InterceptorsModule
                ],
                exports: [
                    InterceptorsModule
                ],
                providers: []
            }]
    }], null, null); })();

//use in app module providers
//{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
class ErrorInterceptor {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    intercept(request, next) {
        return next.handle(request).pipe(catchError(err => {
            console.log(err);
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                //location.reload(true);
            }
            const error = err.error.message || err.statusText;
            return throwError(err);
        }));
    }
}
ErrorInterceptor.ɵfac = function ErrorInterceptor_Factory(t) { return new (t || ErrorInterceptor)(ɵɵinject(AuthenticationServiceAbs)); };
ErrorInterceptor.ɵprov = ɵɵdefineInjectable({ token: ErrorInterceptor, factory: ErrorInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthenticationServiceAbs }]; }, null); })();

/*
 * Public API Surface of fr-base-services
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ErrorInterceptor, FrBaseServicesModule, InterceptorsModule, JwtInterceptor };
//# sourceMappingURL=fr-base-services.js.map
